/**
 * URL-hash keys for the system-logs drawer, bound via `useHashDialog`
 * (see `@/hooks/use-hash-dialog`). App-shell overlays use a simple global key
 * since they are route-agnostic.
 */
export const SYSTEM_LOGS_HASH = {
  /** `#logs` — SystemLogsDrawer (`<Sheet>`). */
  drawer: 'logs'
} as const;

export type SystemLogsHashKey =
  (typeof SYSTEM_LOGS_HASH)[keyof typeof SYSTEM_LOGS_HASH];
